<section class="header" data-p13n-header>
  <header class="site-header-container">
    <div class="inner-container grid-container">
      <button class="navigation-toggle" tabindex="0" (click)="toggleMenu()" [ariaLabel]="active ? 'Close navigation menu' : 'Open navigation menu'"
        [ngClass]="{ active: active }" *ngIf="headerData?.navigationCollection?.items?.length">
        <i class="fal fa-bars" *ngIf="!active"></i>
        <i class="fal fa-xmark" *ngIf="active"></i>
      </button>
      <div class="logo-container" [ngClass]="{'no-navigation': headerData.navigationCollection?.items?.length === 0}">
        @if (headerData.logoLink) {
          @if (headerData.logoLink === '/') {
            <a tabindex="0" [routerLink]="headerData.logoLink">
              <img [src]="headerData.logoImageUrl || headerData.logo?.url" [alt]="headerData.logo?.description || 'Purdue Global'">
            </a>
          } @else {
            <a tabindex="0" [href]="logoUrl">
              <img [src]="headerData.logoImageUrl || headerData.logo?.url" [alt]="headerData.logo?.description || 'Purdue Global'">
            </a>
          }
        } @else if (headerData.logo) {
          <img [src]="headerData.logoImageUrl || headerData.logo?.url" [alt]="headerData.logo?.description || 'Purdue Global'">
        }
        <div class="partner-logo-container" *ngIf="showPartnerLogo && !headerData?.hidePartnerLogo && (partnerInfo?.whiteLogoUrl || partnerInfo?.name)">
            <div class="partner-logo-divider"></div>
            <div *ngIf="partnerInfo?.whiteLogoUrl; else partnerText" class="partner-logo">
              <img [src]="partnerInfo.whiteLogoUrl" [alt]="partnerInfo.name || 'Partner Logo'">
            </div>
            <ng-template #partnerText>
              <p class="partner-name">{{ partnerInfo.name }}</p>
            </ng-template>
        </div>
      </div>
      <div class="phone-number-cta">
        <a *ngIf="headerData?.contactUsPhoneNumber" tabindex="0" [href]="'tel:'+headerData.contactUsPhoneNumber"
          class="phone-link" [class.p13n-skeleton]="isPhonePzd" [class.phone-skeleton]="isPhonePzd" [ariaLabel]="'Call us at ' + headerData.contactUsPhoneNumber">
          <i class="fal fa-phone"></i>
          <span>{{headerData.contactUsPhoneNumber}}</span>
        </a>
        <a *ngIf="headerData?.stdLoginTxt && headerData?.stdLoginLink" tabindex="0" target="_blank" [href]="studentLoginUrl" [ariaLabel]="headerData.stdLoginTxt"
          class="login-link">
          <i class="fal fa-sign-in"></i>
          <span>{{headerData.stdLoginTxt}}</span>
        </a>

        <div class="search-icon" *ngIf="headerData?.search">
          <button class="text-center" id="openMobileSearch" [ariaLabel]="isSearchOpen ? 'Close search' : 'Open search'"
            (click)="openSearchBox()">
            <span>
              <i class="far fa-search" *ngIf="!isSearchOpen"></i>
              <i class="fal fa-xmark" *ngIf="isSearchOpen"></i>
            </span>
          </button>
        </div>
      </div>
      <div class="buttons-container Black" *ngIf="headerData?.buttonLink1 || headerData?.buttonLink2">
        <lib-link *ngIf="headerData?.buttonLink1 as buttonLink1" [childClass]="'btn secondary-button'"
          [internalLink]="buttonLink1.internalLink?.url" [linkTitle]="buttonLink1.linkTitle"
          [target]="buttonLink1.linkTarget" [externalLink]="buttonLink1.externalLink"
          [documentLink]="buttonLink1.docLink" [fragment]="buttonLink1.jumpTarget"></lib-link>

          <lib-link *ngIf="headerData?.buttonLink2 as buttonLink2" [childClass]="'btn primary-button'"
          [internalLink]="applyNowUrl ? '' : buttonLink2.internalLink?.url" [linkTitle]="buttonLink2.linkTitle"
          [target]="buttonLink2.linkTarget" [externalLink]="applyNowUrl || buttonLink2.externalLink"
          [documentLink]="buttonLink2.docLink" [fragment]="buttonLink2.jumpTarget"></lib-link>
      </div>
    </div>
  </header>

  <div class="submenu" [ngClass]="{ active: active }" *ngIf="headerData?.navigationCollection">
    <app-nav-menu 
      [items]="headerData.navigationCollection.items" 
      [phoneNumber]="headerData.contactUsPhoneNumber" 
      [contactUsChat]="headerData.contactUsChat" 
      [contactUsLinkTitle]="headerData.contactUsLinkTitle"
      [contactUsLink]="headerData.contactUsLink"
      [isSearchEnable]="headerData.search" 
      [searchItems]="headerData.mostCommonSearch" 
    />
  </div>

   <!-- mobile search modal -->
  <div class="search-modal" *ngIf="isSearchOpen && isMobile">
    <app-search-modal [searchItems]="headerData.mostCommonSearch" (closeSearch)="isSearchOpen = false"></app-search-modal>
  </div>

  <div class="header-buttons-container Gray" *ngIf="headerData?.buttonLink1 || headerData?.buttonLink2">
    <lib-link *ngIf="headerData?.buttonLink1 as buttonLink1" [childClass]="'btn secondary-button'"
      [internalLink]="buttonLink1.internalLink?.url" [linkTitle]="buttonLink1.linkTitle"
      [target]="buttonLink1.linkTarget" [externalLink]="buttonLink1.externalLink"
      [documentLink]="buttonLink1.docLink" [fragment]="buttonLink1.jumpTarget"></lib-link>

      <lib-link *ngIf="headerData?.buttonLink2 as buttonLink2" [childClass]="'btn primary-button'"
        [internalLink]="applyNowUrl ? '' : buttonLink2.internalLink?.url" [linkTitle]="buttonLink2.linkTitle"
        [target]="buttonLink2.linkTarget" [externalLink]="applyNowUrl || buttonLink2.externalLink"
        [documentLink]="buttonLink2.docLink" [fragment]="buttonLink2.jumpTarget"></lib-link>
  </div>
</section>